import { Column, Row, RowCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import { ReactComponent as OrderRightSvg } from 'assets/svgs/order_right.svg'
import { ReactComponent as OrderWarnSvg } from 'assets/svgs/order_warn.svg'
import { ReactComponent as OrderErrorSvg } from 'assets/svgs/order_error.svg'
import { ReactComponent as OrderDeleteSvg } from 'assets/svgs/order_delete.svg'
import { ReactComponent as CopySvg } from 'assets/svgs/copy.svg'
import { ReactComponent as BrowserSvg } from 'assets/svgs/browser_icon.svg'
import { CopyToClipboard } from "react-copy-to-clipboard";
import ImgCom from "components/ImgCom"
import { useCallback, useEffect, useState } from "react"
import { shortStr } from "utils"
import useOrder from "hooks/useOrder"
import { removeOrderStore } from "utils/store"
import { ChaingeChain } from "types/baseType"
import chainRpcs from "data/chainRpc"
import { mainnet, useAccount } from "wagmi"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { createWalletClient, custom } from "viem"
import { postSubmitOrder } from "services/commonServices"
import { setWalletWinOpened } from "hooks/redux/slices/walletSlice"

const Orders = () => {
    const [curId, setCurId] = useState('-1')
    const { address, connector } = useAccount()
    const { isConnected } = useAppSelector((state) => state.wallet)
    const dispatch = useAppDispatch()

    const { orderList, checkOrderList } = useOrder()
    const getStatusIcon = useCallback((status: string) => {
        if(status === 'pending') {
            return <OrderWarnSvgWrap></OrderWarnSvgWrap>
        } else if(status === 'failed') {
            return <OrderErrorSvgWrap></OrderErrorSvgWrap>
        } else {
            return <OrderRightSvgWrap></OrderRightSvgWrap>
        }
    }, [])

    const fnCancel = () => {
      setCurId('-1')
    }

    const fnConfirm = (id: string) => {
      removeOrderStore(id)
      setCurId('-1')
      checkOrderList("delete")
    }


    const fnOpenBrowser = (item: any, directon: string) => {
      let openUrl = ''
      let curChain = item.fromChain as ChaingeChain
      let curHash = item.hash
      if(directon === 'from') {
        curChain = item.fromChain as ChaingeChain
        curHash = item.hash
      } else {
        curChain = item.toChain as ChaingeChain
        curHash = item.execHash || ''
      }
      const rpcObj = (chainRpcs as any)[curChain.network]
      if(item.isBrc20 && curChain.nickName === 'BTC') {
        openUrl = `https://www.blockchain.com/explorer/transactions/btc/${item.hash}`;
      } else {
        openUrl = `${rpcObj['scanUrl']}/tx/${curHash}`
      }
      window.open(openUrl, '_blank')
    }

    const fnSubmitAgain = useCallback(async (item: any) => {
      try {
          if(!isConnected) {
            dispatch(setWalletWinOpened(true))
            return
          }
          item = {...item}
          const provider = await connector?.getProvider()
          const fromAddress = address  as `0x${string}`
          const walletClient = createWalletClient({
            account: fromAddress,
            chain: mainnet,
            transport: custom(provider)
          }) as any
          let signature = await walletClient?.signMessage({ 
            account: fromAddress,
            message: item.submitInfo.raw,
          })
          signature = signature.substring(2)
          const headers = {
              EvmAddress: fromAddress,
              Signature: signature
          }
          item.submitInfo.headers = headers
          await postSubmitOrder(item.submitInfo.params, headers, item)
          checkOrderList("refresh")
      } catch(error) {
        
      }
    }, [address, checkOrderList, connector, dispatch, isConnected])


    return <OrdersWrap>
        <EmptyColumn></EmptyColumn>
        <OutWrap>
            <PageTitleWrap $roobertSemiBold>Orders</PageTitleWrap>
            <HeaderWrap>
                <HeaderItemWrap $flex1="1" $pl="25px">Status</HeaderItemWrap>
                <HeaderItemWrap $flex1="1.5">You paid</HeaderItemWrap>
                <HeaderItemWrap $flex1="1.5">You got</HeaderItemWrap>
                {/* <HeaderItemWrap $flex1="1">Details</HeaderItemWrap> */}
                <HeaderItemWrap $width="80px"></HeaderItemWrap>
            </HeaderWrap>
            <StyledContainer $height="20px"></StyledContainer>
            <OrderScrollWrap>
                {
                    orderList.map((item: any, index) => <OrderCardWrap key={index}>
                    <Row $ml="10px" $flex1="1">
                        {
                            getStatusIcon(item.status)
                        }
                        <Column $ml="15px">
                            <StyledContainer $fontSize="14px" $lineHeight="14px" $fontWeight6 $roobertSemiBold>Swap</StyledContainer>
                            <StyledContainer $fontSize="14px" $lineHeight="14px" $fontWeight6 $roobertSemiBold>{item.statusStr}</StyledContainer>
                            <StyledContainer $mt="8px" $fontSize="12px" $lineHeight="14px" $fontWeight4 $roobertRegular>{item.showDate}</StyledContainer>
                        </Column>
                    </Row>
                    <Column $flex1="1.5">
                      <Row>
                          <ImgCom imgUrl={item.fromTokenImgUrl}></ImgCom>
                          <Column $ml="12px">
                              <StyledContainer $mb="6px" $fontSize="14px" $lineHeight="14px" $fontWeight6 $roobertSemiBold>{item.fromAmountStr} {item.fromToken.symbol}</StyledContainer>
                              <StyledContainer $fontSize="12px" $lineHeight="12px" $color="#767A7F" $fontWeight4 $roobertRegular>On {item.fromChain.fullName}</StyledContainer>
                          </Column>
                      </Row>
                      <StyledContainer $mt="20px">
                        <HashHandlerItem certHash={item?.hash || ''} openBrowser={() => fnOpenBrowser(item, 'from')}></HashHandlerItem>
                      </StyledContainer>
                    </Column>
                    <Column $flex1="1.5">
                      <Row>
                          <ImgCom imgUrl={item.toTokenImgUrl}></ImgCom>
                          <Column $ml="12px">
                              {
                                !item.isBrc20 && <StyledContainer $mb="6px" $fontSize="14px" $lineHeight="14px" $fontWeight6 $roobertSemiBold>{item.toAmountStr} {item.toToken.symbol}</StyledContainer>
                              }
                              <StyledContainer $fontSize="12px" $lineHeight="12px" $color="#767A7F" $fontWeight4 $roobertRegular>On {item.toChain.fullName}</StyledContainer>
                          </Column>
                      </Row>
                      <StyledContainer $mt="20px">
                        <HashHandlerItem certHash={item?.execHash || ''} openBrowser={() => fnOpenBrowser(item, 'to')}></HashHandlerItem>
                      </StyledContainer>
                    </Column>
                    {/* <Row $flex1="1">
                        <HashHandlerItem certHash={item.hash} openBrowser={() => fnOpenBrowser(item)}></HashHandlerItem>
                    </Row> */}
                    <RowCenter $width="80px" >
                        {
                          (item.id || item.status=== 'failed')&& <OrderDeleteSvgWrap onClick={() => setCurId(item.id)}></OrderDeleteSvgWrap>
                        }
                        {
                          (!item?.id && item.status === 'pending')&& <SubmitBtnWrap onClick={() => fnSubmitAgain(item)}>Resume</SubmitBtnWrap>
                        }
                    </RowCenter>
                    {
                      curId === item.id &&  <ConfirmDelOrder onCancel={fnCancel} onConfirm={() => fnConfirm(item.id)}></ConfirmDelOrder>
                    }
                </OrderCardWrap>)
                }
            </OrderScrollWrap>
            
        </OutWrap>
    </OrdersWrap>
}


export const HashHandlerItem = ({
    certHash,
    openBrowser,
    showBrowser = true,
    fontSize = '12px',
    lineHeight = '14px',
  }: {
    certHash: string
    openBrowser?: () => void
    showBrowser?: boolean
    fontSize?: string
    lineHeight?: string
  }) => {
    const [isCopy, setIsCopy] = useState(false);
    useEffect(() => {
      if (isCopy) {
        setTimeout(() => {
          setIsCopy(false);
        }, 2000);
      }
    }, [isCopy]);
  
    return (
      <HashHandlerBox>
        <StyledContainer $fontSize={fontSize} $lineHeight={lineHeight} $mr="8px" $fontWeight6 $roobertSemiBold>
          Hash:
        </StyledContainer>
        {
          certHash ? <>
            <StyledContainer $fontSize={fontSize} $lineHeight={lineHeight} $width="80px">
              {isCopy ? "Copied" : certHash ? shortStr(certHash, 4) : ""}
            </StyledContainer>
            <CopyToClipboard text={certHash || ""} onCopy={() => setIsCopy(true)}>
              <ImgBox>
                <CopySvgWrap></CopySvgWrap>
              </ImgBox>
            </CopyToClipboard>
            {
              showBrowser && <ImgBox $ml="4px" onClick={openBrowser}>
                <BrowserSvgWrap></BrowserSvgWrap>
              </ImgBox>
            }
          </>: <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight5>
            Not available yet
          </StyledContainer>
        }
        
      </HashHandlerBox>
    );
};


type ConfirmProps = {
  onConfirm: () => void;
  onCancel: () => void;
}
const ConfirmDelOrder = ({onConfirm, onCancel}:ConfirmProps) => {
  return <ConfirmBox>
    <StyledContainer $fontSize="12px" $roobertRegular $mr="20px">Delete the order?</StyledContainer>
    <Row>
      <ConfirmBtn onClick={onConfirm}>Confirm</ConfirmBtn>
      <CnacelBtn onClick={onCancel}>Cancel</CnacelBtn>
    </Row>
  </ConfirmBox>
}


const marginStyle = () => {
    return css`
        margin-left: 50px;
        margin-right: 50px;
    `
}

const paddingStyle = () => {
    return css`
        padding-left: 50px;
        padding-right: 50px;
    `
}

const OrdersWrap = styled(StyledContainer)`
    display: flex;
    min-height: 100vh;
    flex: 1;
`

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
  }
`

const OutWrap = styled(StyledContainer)`
    flex: 9;
    background-color: ${({theme}) => theme.basicWhite};
    position: relative;

    padding: 70px 0;
`

const PageTitleWrap = styled(StyledContainer)`
    font-size: 22px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 20px;

    ${marginStyle()}
`

const HeaderWrap = styled(Row)`
  background-color: #F4F5F5;
  border-radius: 6px;
  padding: 18px 0px;

  ${marginStyle()}
`

const HeaderItemWrap = styled(StyledContainer)`
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
`

const OrderCardWrap = styled(Row)`
  padding: 25px 15px;
  background-color: #fff;
  border-radius: 9px;
  box-shadow: 0px 4px 4px -2px rgba(24, 39, 75, 0.08), 0px 2px 4px -2px rgba(24, 39, 75, 0.12);
  margin-bottom: 8px;

  position: relative;
`


const svgStyle = () => {
    return css`
        width: 36px;
        height: 36px;
    `
}
const OrderRightSvgWrap = styled(OrderRightSvg)`
    ${svgStyle()}
`
const OrderWarnSvgWrap = styled(OrderWarnSvg)`
    ${svgStyle()}
`
const OrderErrorSvgWrap = styled(OrderErrorSvg)`
    ${svgStyle()}
`
const OrderDeleteSvgWrap = styled(OrderDeleteSvg)`
    width: 26px;
    height: 26px;
    cursor: pointer;
`

const CopySvgWrap = styled(CopySvg)`
    width: 14px;
    height: 14px;
`

const BrowserSvgWrap = styled(BrowserSvg)`
    width: 14px;
    height: 14px;
    rect, path {
        fill: #767A7F;
    }
`
const HashHandlerBox = styled(StyledContainer)`
  background-color: #F4F5F5;
  border-radius: 4px;
  box-sizing: border-box;
  height: 38px;
  padding: 6px 8px;

  display: inline-flex;
  align-items: center;
`;

const ImgBox = styled(Row)`
  box-sizing: border-box;
  padding: 6px;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
`;

const OrderScrollWrap = styled.div`
    height: calc(100vh - 140px - 120px);
    overflow: auto;
    ${paddingStyle()}
`

const ConfirmBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(10, 10, 10, 0.8);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);

  padding: 15px;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
`

const HelpBtn = styled(StyledContainer)`
  padding: 8px 15px;
  border-radius: 4px;
  background-color: #f0f3f9;
  font-size: 12px;
  font-weight: 500;
  margin-right: 5px;
  cursor: pointer;
`;


const CnacelBtn = styled(HelpBtn)`
  margin-right: 0;
  padding: 8px 8.5px;
  margin-left: 5px;
`

const ConfirmBtn = styled(CnacelBtn)`
  padding: 8px 8.5px;
  margin-left: 0px;
  background-color: #ffebed;
  color: #D11026;
`

const SubmitBtnWrap = styled(Row)`
  font-size: 12px;
  line-height: 1;
  color: #4D1DF7;
  padding: 5px 8px;
  border: 1px solid #4D1DF7;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    color: #fff;
    background-color: #4D1DF7;
  }
`

export default Orders